import { HubCardDataOptions, useHubCardData } from './use-hub-card-data';
import { HubCardType } from '@/types';

export const useMonthlyCommissionData = (options?: HubCardDataOptions) => {
  const { data, loading, error } = useHubCardData(
    HubCardType.MonthlyCommissions,
    options,
  );

  return {
    data: data ? data.cardData[0] : undefined,
    error,
    loading,
  };
};
